<div class="dialog-container">

  <div class="dialog-header">
    <h2 class="dialog-title">{{ 'request_v2.linked_status_dialog.title' | translate }}</h2>
    <button type="button" class="close-btn" (click)="cancel()">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <div class="dialog-body">
    <div class="dialog-row"
         *ngFor="let row of rows; let i = index"
         [class.deselected]="!row.selected"
         (click)="toggle(i)">

      <mat-checkbox
        [checked]="row.selected"
        (change)="toggle(i)"
        (click)="$event.stopPropagation()">
      </mat-checkbox>

      <div class="row-info">
        <span class="row-display-id">{{ row.displayId }}</span>
        <span class="row-title">{{ row.title }}</span>
      </div>

      <div class="row-statuses">
        <span class="status-pill"
              [style.background]="getStatusBg(row.currentStatus?.color)">
          <span class="status-dot" [style.background]="row.currentStatus?.color"></span>
          {{ row.currentStatus?.name | titlecase }}
        </span>
        <mat-icon class="arrow-icon">arrow_forward</mat-icon>
        <span class="status-pill"
              [style.background]="getStatusBg(data.newStatus?.color)">
          <span class="status-dot" [style.background]="data.newStatus?.color"></span>
          {{ data.newStatus?.name | titlecase }}
        </span>
      </div>

    </div>
  </div>

  <div class="dialog-footer">
    <button type="button" class="btn-ignore" (click)="cancel()">
      {{ 'request_v2.linked_status_dialog.ignore' | translate }}
    </button>
    <button type="button" class="btn-apply" (click)="apply()" [disabled]="selectedCount === 0">
      <mat-icon>auto_awesome</mat-icon>
      {{ 'request_v2.linked_status_dialog.apply' | translate }}
    </button>
  </div>

</div>
